import React, { useCallback, useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import {
    Grid,
    Stack,
    Box,
    Typography,
} from "@mui/material";
import LoadingButton from "@mui/lab/LoadingButton";

import {
    Input,
    Select,
    CommonModal,
} from '../Common/index';
import { trakrefBlue } from '../../color_utils';
import { trakrefFontFamilyBold } from '../../utils';
import { GethAssetIdentityTypes } from '../../CodesCache';
import Routes from '../../routes';
import { sensor_type_options } from '../AddAsset/utils';
import toast from 'react-hot-toast';

const AddSensorModal = ({
    open,
    closeModal,
    assetName,
    assetId
}) => {
    const [isLoading, setIsLoading] = useState(false);
    const [name, setName] = useState();
    const [sensorType, setSensorType] = useState();
    const [sensorLocation, setSensorLocation] = useState();
    const [ErrorObject, setErrorObject] = useState({});
    const headerName = `Create Sensor: ${assetName}`;
    const buttonTitle = "Add Sensor";

    const onModalClose = () => {
        setSensorLocation(null);
        setSensorType(null);
        setName(null)
        closeModal();
    }

    const validateFields = () => {
        const errorObject = {};
        let isValid = true;

        if (!name) {
            errorObject.name = true;
        }

        if (!sensorType) {
            errorObject.sensorType = true;
        }
        if (!sensorLocation) {
            errorObject.sensorLocation = true;
        }

        setErrorObject(errorObject);
        if (Object.values(errorObject).some(state => state == true)) {
            isValid = false;
        }
        return isValid;
    };

    const onSave = async () => {
        try {
            setIsLoading(true);

            if (!validateFields()) {
                setIsLoading(false);
                return;
            }

            const body = {
                RefrigerantLeakMonitorID: assetId,
                LeakMonitorSensorTypeID: sensorType,
                Name: name,
                SensorLocation: sensorLocation,
            }

            const response = await fetch(Routes.Asset.AddSensor(), {
                method: 'POST',
                headers: {
                    Accept: "application/json",
                    "Content-Type": "application/json",
                },
                body: JSON.stringify(body)
            });

            if (response.status === 200) {
                toast.success('Sensor has been successfully created.', { duration: 6000 });
            } else {
                toast.error('There was an error saving the sensor.', { duration: 6000 });
            }
            onModalClose();
        }
        catch {
            setIsLoading(false);
        }
        finally {
            setIsLoading(false);
        }
    }

    return (
        <CommonModal
            open={open}
            close={onModalClose}
            header={headerName}
            bottom={24}
            scroll="paper"
        >
            <Grid container pl={10} pr={10}>
                <Grid item xs={12} lg={12} mb={2} pt={2} align="center">
                    <Stack spacing={3}>
                        <Input
                            required
                            fullWidth
                            variant={"standard"}
                            label={"Name"}
                            value={name}
                            onChange={(e) => setName(e.target.value)}
                            error={ErrorObject.name}
                            maxCharacterLength={150}
                        />
                        <Select
                            required
                            fullWidth
                            variant={"standard"}
                            label="Alias Type"
                            options={sensor_type_options}
                            value={sensorType}
                            onChange={(e) => setSensorType(e.target.value)}
                            error={ErrorObject.sensorType}
                        />
                        <Input
                            required
                            fullWidth
                            variant={"standard"}
                            label={"Sensor Location"}
                            value={sensorLocation}
                            onChange={(e) => setSensorLocation(e.target.value)}
                            error={ErrorObject.sensorLocation}
                            maxCharacterLength={150}
                        />
                    </Stack>
                </Grid>
                <Grid item xs={12} lg={12} align="center">
                    <Box mt={2} mb={2} sx={{ width: "100%" }}>
                        <LoadingButton
                            fullWidth
                            size="large"
                            variant="contained"
                            loading={isLoading}
                            onClick={onSave}
                            sx={{
                                "& .MuiCircularProgress-root": {
                                    color: "#FFFFFF",
                                    width: "21px !important",
                                    height: "21px !important",
                                },
                            }}
                            style={{
                                backgroundColor: trakrefBlue,
                            }}
                        >
                            <Typography
                                sx={{
                                    fontFamily: trakrefFontFamilyBold,
                                    color: isLoading ? "transparent" : "#fff",
                                    backgroundColor: trakrefBlue,
                                    letterSpacing: "1.2px",
                                    padding: "1% 0%",
                                    fontSize: 17,
                                    fontWeight: 400,
                                }}
                            >
                                {buttonTitle}
                            </Typography>
                        </LoadingButton>
                    </Box>
                </Grid>
            </Grid>
        </CommonModal>
    );
};

AddSensorModal.propTypes = {
    open: PropTypes.bool.isRequired,
    closeModal: PropTypes.func.isRequired,
    assetName: PropTypes.string.isRequired,
    assetId: PropTypes.number.isRequired,
};

export default AddSensorModal;
